module.exports = __webpack_public_path__ + "img/bluesky16.cf455b78.jpg";